module.exports = __webpack_public_path__ + "media/images/401playlogowhite-89f652ff.png";